module.exports = __webpack_public_path__ + "img/logo-hpu-ftugm.d421f968.png";